import { useMemo } from "react";
import { useCheckoutStore } from "../store/checkout-store";
import { useCheckoutAddresses } from "./use-checkout-addresses";
import { useCheckoutAgreements } from "@/api/hooks/use-query-api";
import useAuthStore from "@/store/use-auth-store";
import type { CheckoutAgreementsRequest } from "@/api/models/api-types";

export const useCheckoutAgreementsData = () => {
  const { buyNowOfferId } = useCheckoutStore();
  const { addresses, selectedDeliveryAddressId } = useCheckoutAddresses();
  const userRegion = useAuthStore((state) => state.user?.region || "");

  const selectedAddress = useMemo(
    () => addresses.find((address) => address._id === selectedDeliveryAddressId),
    [addresses, selectedDeliveryAddressId]
  );

  const requestPayload = useMemo<CheckoutAgreementsRequest | null>(() => {
    if (!selectedAddress) return null;

    const addressAny = selectedAddress as any;

    return {
      shippingAddress: {
        label: selectedAddress.label || "",
        firstName: selectedAddress.firstName || "",
        lastName: selectedAddress.lastName || "",
        addressLine1: selectedAddress.addressLine1 || "",
        addressLine2: selectedAddress.addressLine2 || "",
        city: selectedAddress.city || "",
        cityId: typeof addressAny.cityId === "number" ? addressAny.cityId : 0,
        state: selectedAddress.state || "",
        postalCode: selectedAddress.postalCode || "",
        country: selectedAddress.country || "",
        countryId:
          typeof addressAny.countryId === "number" ? addressAny.countryId : 0,
        phone: selectedAddress.phone || "",
        quarter: typeof addressAny.quarter === "string" ? addressAny.quarter : "",
        quarterId:
          typeof addressAny.quarterId === "string" ? addressAny.quarterId : "",
        townId: typeof addressAny.townId === "number" ? addressAny.townId : 0,
      },
      region: userRegion || selectedAddress.country || "TR",
    };
  }, [selectedAddress, userRegion]);

  const { data, isLoading, error } = useCheckoutAgreements(
    requestPayload,
    buyNowOfferId
  );

  return {
    agreementTypeGroups: data?.data?.agreementTypeGroups || [],
    isLoading,
    error,
    hasSelectedAddress: Boolean(selectedAddress),
  };
};
